import React, { createContext, useMemo, useState } from "react";
import styled from "styled-components";
import { config } from "./config/config";
import { useQuery } from "react-query";
import apiService from "../../../../api/apiService";
import { TopBar } from "./components/TopBar";
import TableHead from "./components/TableHead";
import TableBody from "./components/TableBody";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { demoEnv } from "../../../../utils/const/query-key";

export const TableInstanceContext = createContext(null);

const TableWrapper = styled.div`
  border: 1px solid var(--color-table-wrapper);
`;

const Table = styled.table`
  user-select: none;
  border-collapse: collapse;
  overflow-x: auto;
  width: 100%;
  table-layout: fixed;
`;

const HeightWrapper = styled.div`
  height: 450px;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
`;

const EnvResultsTable = () => {
  const [deletingRowId, setDeletingRowId] = useState(null);

  const { data } = useQuery(demoEnv, () =>
    apiService.getEnvironmentData()
  );
  const tableData = useMemo(
    () => (Array.isArray(data) ? data : []),
    [data]
  );
  const tableConfig = {
    columns: config.columns,
    data: tableData,
    initialState: {
      height: "50px",
      sortBy: [
        {
          id: "creation-date",
          desc: true,
        },
      ],
    },
  };

  const tableInstance = useTable(
    tableConfig,
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { getTableProps } = tableInstance;

  return (
    <TableInstanceContext.Provider value={{ tableInstance }}>
      <TableWrapper id={"demopoint-wrapper-table"}>
        <TopBar />
        <HeightWrapper>
          <Table {...getTableProps()} id={"demopoint-main-table"}>
            <TableHead />
            <TableBody deletingRowId={deletingRowId} setDeletingRowId={setDeletingRowId} />
          </Table>
        </HeightWrapper>
        <TopBar />
      </TableWrapper>
    </TableInstanceContext.Provider>
  );
};

export default EnvResultsTable;
